<script>
import ProductCreate from "@/views/modules/products/ProductCreate.vue";

export default {
  name: "ProductCreatePageID",
  components: {
    ProductCreate
  }
}
</script>

<template>
  <ProductCreate lang="ID" />
</template>

<style scoped>
</style>
